import { render } from "./VideoWallPlayerLoader.vue?vue&type=template&id=16d70e18&ts=true"
import script from "./VideoWallPlayerLoader.vue?vue&type=script&lang=ts"
export * from "./VideoWallPlayerLoader.vue?vue&type=script&lang=ts"

import "./VideoWallPlayerLoader.vue?vue&type=style&index=0&id=16d70e18&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__